import { defineMessages, type MessageDescriptor } from 'react-intl';

export const i18n: Record<string, Required<MessageDescriptor>> = defineMessages({
	unableToLoadCommentsTitle: {
		id: 'comments-util.error.unable.to.load.comments',
		defaultMessage: 'Unable to load comments',
		description:
			'The title of the flag shown to a user that says their comments could not be loaded',
	},
	networkError: {
		id: 'comments-util.error.network',
		defaultMessage:
			'A network error was encountered when loading comments. Please try refreshing the page.',
		description: 'A message explaining a network error occurred',
	},
	viewNotPermitted: {
		id: 'comments-util.error.view.not.permitted',
		defaultMessage:
			'Your permission settings don’t allow you to view comments on this page. Check with your administrator if you need this ability.',
		description: "A message informing the user they don't have permissions to view page comments",
	},
	createNotPermitted: {
		id: 'comments-util.error.create.not.permitted',
		defaultMessage:
			'You can’t create comments in this space. A space admin can modify your permissions.',
		description: "A message informing the user they don't have permissions to create comments",
	},
	unexpectedError: {
		id: 'comments-util.error.unexpected',
		defaultMessage: 'Something went wrong when loading comments on this page.',
		description: 'A message explaining an unexpected error occurred',
	},
});
